import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ActionButton from 'components/common/ActionButton';
import PageHeader from 'components/common/PageHeader';

const ListTenders = () => {
  const [tenders, setTenders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setError(null);
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/tenders/list`
        );
        // console.log(response.data);
        setTenders(response.data);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const archiveDocument = async (id, name) => {
    if (
      window.confirm(`Are you sure you want to delete this tender: ${name}?`)
    ) {
      try {
        setError(null);
        await axios.put(
          `${process.env.REACT_APP_API_URL}/tenders/archive/id/${id}`
        );
        setTenders(tenders.filter((tender) => tender.id !== id));
        toast.success(`${name} Tender deleted successfully`, {
          theme: 'colored',
        });
      } catch (error) {
        setError(error.message);
      }
    }
  };

  return (
    <>
      <PageHeader title='Tenders' description='' className='mb-3'></PageHeader>
      {loading ? (
        <div>Loading...</div>
      ) : error ? (
        <div>Error: {error}</div>
      ) : (
        <Table hover responsive>
          <thead>
            <tr>
              <th scope='col'>Name</th>
              <th scope='col'>Contact</th>
              <th scope='col'>Status</th>
              <th scope='col'>Closing Date</th>
              <th className='text-end' scope='col'>
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {tenders.length > 0 &&
              tenders.map((item, index) => (
                <tr key={index}>
                  <td>
                    <Link to={`/tender/${item.id}`}>
                      {item.name}
                    </Link>
                  </td>
                  <td>{item.contact}</td>
                  <td>{item.status}</td>
                  <td>{item.closing_date}</td>
                  <td className='text-end'>
                    <Link to={`/tenders/edit/${item.id}`}>
                      <ActionButton
                        icon='edit'
                        title='Edit'
                        variant='action'
                        className='p-0 me-2'
                      />
                    </Link>
                    <ActionButton
                    icon='trash-alt'
                    title='Delete'
                    variant='action'
                    className='p-0'
                    alt='Delete'
                    onClick={() => archiveDocument(item.id, item.name)}
                  />
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default ListTenders;